import React from 'react';
import { IIconProps } from './utils';

export const ChevronLeft = ({
  fill = 'currentColor', height = 21, width = 21, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M18.75 7.5L12.1339 14.1161C11.6457 14.6043 11.6457 15.3957 12.1339 15.8839L18.75 22.5"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
